/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import { connect } from 'react-redux';
import {
  updateSponsorSelection,
  hideModal,
  throwSelectSponsorError,
  throwUserAllocationsError,
  logOutAndCleanSession,
  selectTenantAndSetCookie
} from '../../actions/actions';
import SponsorsModal from './sponsors.modal';
import { USER_ALLOCATION_ERROR_MSG, SELECT_SPONSOR_ERROR_MSG } from '../../const';
import { SELECTED_SPONSOR } from '../../constants/common';
import { createSelector } from 'reselect';
import { withRouter } from 'react-router-dom';

export const getSortedSponsors = createSelector(
  (state) => state,
  (state) => {
    let allocations = state.login.user.allocations;
    let items = [];
    let selectedSponsorType = state.sponsor.selectedSponsor ? state.sponsor.selectedSponsor.type : 'PRODUCTION';
    let sortedAllocations = allocations
      .filter((a) => {
        if (items[a.databasename]) return false;
        items[a.databasename] = true;
        return true;
      })
      .sort((a, b) => a.databasename.localeCompare(b.databasename));
    let filteredAllocations = sortedAllocations.filter((a) => a.type === selectedSponsorType);
    return filteredAllocations && filteredAllocations.length != 0 ? filteredAllocations : allocations;
  }
);

export const mapStateToProps = (state, ownProps) => {
  return {
    selectedSponsor: state.sponsor.selectedSponsor,
    updatedSponsor: state.sponsor.updatedSponsor,
    sponsors: getSortedSponsors(state),
    selectSponsorError: state.sponsor.selectSponsorError,
    userAllocationsError: state.sponsor.userAllocationsError,
    logoutUrl: state.login.clientConfiguration.SSOLogoutUrl
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    signOut: (SSOLogoutUrl) => {
      dispatch(logOutAndCleanSession(SSOLogoutUrl));
    },

    loadSponsors: (sponsors) => {
      if (!sponsors || sponsors.length === 0) dispatch(throwUserAllocationsError(USER_ALLOCATION_ERROR_MSG));
    },

    updateSponsorSelection: (e) => {
      let sponsor;
      if (e.target.value !== '') {
        sponsor = JSON.parse(e.target.value);
        dispatch(updateSponsorSelection(sponsor));
      }
    },

    selectTenantAndSetCookie: (selectedSponsor) => {
      const { history } = ownProps;
      if (selectedSponsor) {
        sessionStorage.setItem(SELECTED_SPONSOR, JSON.stringify(selectedSponsor));
        dispatch(selectTenantAndSetCookie(selectedSponsor, history));
        dispatch(hideModal());
      } else {
        dispatch(throwSelectSponsorError(SELECT_SPONSOR_ERROR_MSG));
      }
    },

    closeModal: () => {
      dispatch(hideModal());
    }
  };
};

const SponsorsModalContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(SponsorsModal));

export default SponsorsModalContainer;
